import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Typography,
  Grid,
  Button,
  Divider,
  TextField,
  InputAdornment
} from "@material-ui/core";
import React, { useContext, useEffect, useState } from "react";
import { filterContext } from "../../_context/filterContext";
import HighlightOffRoundedIcon from "@material-ui/icons/HighlightOffRounded";

const useStyles = makeStyles(theme => ({
  root: theme.filterPaper,
  divider: theme.divider,
  labels: theme.datePriceLabels,
  inputField: {
    ...theme.inputField,
    ...theme.inputClearButton
  }
}));

export const PercentRabatPerItemFilter = () => {
  const classes = useStyles();

  const {
    state: { percentRabatPerItemFrom, percentRabatPerItemTo, _update }
  } = useContext(filterContext);

  const [percentFrom, setPercentFrom] = useState(percentRabatPerItemFrom);
  const [percentTo, setPercentTo] = useState(percentRabatPerItemTo);

  useEffect(() => {
    setPercentFrom(percentRabatPerItemFrom);
  }, [percentRabatPerItemFrom, _update]);

  useEffect(() => {
    setPercentTo(percentRabatPerItemTo);
  }, [percentRabatPerItemTo, _update]);

  const selectDiscount = (e, from, to) => {
    e.preventDefault();
    e.stopPropagation();
    setPercentFrom(from);
    setPercentTo(to);
  };

  return (
    <Paper className={classes.root}>
      <Typography variant="h2">Rabat dla pojedyńczego produktu</Typography>
      <Grid container spacing={1}>
        <Grid container item xs={12} spacing={1}>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={e => selectDiscount(e, null, 10)}
            >
              0% - 10%
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={e => selectDiscount(e, 11, 20)}
            >
              11% - 20%
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={e => selectDiscount(e, 21, 30)}
            >
              21% - 30%
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={e => selectDiscount(e, 31, 50)}
            >
              31% - 50%
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={e => selectDiscount(e, 50, null)}
            >
              >50%
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className={classes.labels}>
        <Grid item xs>
          <TextField
            key="percent-item-from"
            label="Rabat od (%)"
            type="number"
            value={(percentFrom !== null ? percentFrom : "0") || ""}
            variant="outlined"
            name="percentRabatPerItemFrom"
            onChange={event => setPercentFrom(event.target.value)}
            className={classes.inputField}
            InputProps={{
              endAdornment: (
                <InputAdornment className={classes.clear} position="end">
                  <HighlightOffRoundedIcon
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                      setPercentFrom(null);
                    }}
                  />
                </InputAdornment>
              )
            }}
          />
        </Grid>
        <Grid item className={classes.divider}>
          <br />
          <Divider />
        </Grid>
        <Grid item xs>
          <TextField
            key="percent-item-to"
            label="Rabat do (%)"
            type="number"
            value={(percentTo !== null ? percentTo : "100") || ""}
            variant="outlined"
            onChange={event => setPercentTo(event.target.value)}
            name="percentRabatPerItemTo"
            className={classes.inputField}
            InputProps={{
              endAdornment: (
                <InputAdornment className={classes.clear} position="end">
                  <HighlightOffRoundedIcon
                    onClick={e => {
                      e.preventDefault();
                      e.stopPropagation();
                      setPercentTo(null);
                    }}
                  />
                </InputAdornment>
              )
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
